import { DocPage } from "../components/DocPage";

export const ssr = { mode: "ssg" as const };

export default function Ssg() {
  return (
    <DocPage
      title="SSG — Landrr.js"
      description="Pre-render static HTML at build time with Landrr.js."
    >
      <h1>Static site generation</h1>
      <p>
        Mark a page for static generation. Landrr pre-renders it at build time
        using the same SSR code path.
      </p>
      <pre>
        <code>{`export const ssr = { mode: "ssg" as const };`}</code>
      </pre>
      <p>Build with the Landrr CLI:</p>
      <pre>
        <code>npm run build</code>
      </pre>
      <p>
        Under the hood, <code>landrr-build</code> runs the Vite client bundle,
        server bundle, then <code>generateStaticSite()</code> from
        <code> @landrr/core/server</code> for every SSG route.
      </p>
      <p>
        Output lands in <code>dist/client</code> — ready for GitHub Pages or any
        static host.
      </p>
    </DocPage>
  );
}
